import {
    MedicalNoteType,
    SourceDocumentType,
    TherapySessionType,
} from '../types';

// TBD: this is not great - think how to get rid of MedicalNoteType.
export const SessionTypeToMedicalNoteTypeMap: Record<
    TherapySessionType,
    MedicalNoteType
> = {
    [TherapySessionType.Intake]: MedicalNoteType.Intake,
    [TherapySessionType.Bps]: MedicalNoteType.Bps,
    [TherapySessionType.Standard]: MedicalNoteType.Progress,
    [TherapySessionType.Soap]: MedicalNoteType.Soap,
    [TherapySessionType.HeadwaySoap]: MedicalNoteType.HeadwaySoap,
    [TherapySessionType.GpSoap]: MedicalNoteType.GpSoap,
    [TherapySessionType.Dap]: MedicalNoteType.Dap,
    [TherapySessionType.Emdr]: MedicalNoteType.Emdr,
    [TherapySessionType.Girp]: MedicalNoteType.Girp,
    [TherapySessionType.Birp]: MedicalNoteType.Birp,
    [TherapySessionType.Custom]: MedicalNoteType.Custom,
    [TherapySessionType.PsychiatricSoap]: MedicalNoteType.PsySoap,
    [TherapySessionType.PsychiatricIntake]: MedicalNoteType.PsyIntake,
    [TherapySessionType.Mse]: MedicalNoteType.Mse,
    [TherapySessionType.CoupleStandard]: MedicalNoteType.CoupleStandard,
    [TherapySessionType.CoupleSoap]: MedicalNoteType.CoupleSoap,
    [TherapySessionType.CoupleDap]: MedicalNoteType.CoupleDap,
    [TherapySessionType.Template]: MedicalNoteType.Template,
} as const;

// TBD: this is not great - think about a better way to remap. Ideally not use MedicalNoteType or SourceDocumentType at all
export const MedicalNoteToSourceDocumentTypeMap: Record<
    MedicalNoteType,
    | SourceDocumentType.INTAKE_NOTE
    | SourceDocumentType.BPS_NOTE
    | SourceDocumentType.PROGRESS_NOTE
    | SourceDocumentType.SOAP_NOTE
    | SourceDocumentType.HEADWAY_SOAP_NOTE
    | SourceDocumentType.GP_SOAP_NOTE
    | SourceDocumentType.DAP_NOTE
    | SourceDocumentType.EMDR_NOTE
    | SourceDocumentType.GIRP_NOTE
    | SourceDocumentType.BIRP_NOTE
    | SourceDocumentType.CUSTOM_NOTE
    | SourceDocumentType.PSY_SOAP_NOTE
    | SourceDocumentType.PSY_INTAKE_NOTE
    | SourceDocumentType.MSE_NOTE
    | SourceDocumentType.COUPLE_DAP_NOTE
    | SourceDocumentType.COUPLE_SOAP_NOTE
    | SourceDocumentType.COUPLE_STANDARD_NOTE
    | SourceDocumentType.TEMPLATE
> = {
    [MedicalNoteType.Intake]: SourceDocumentType.INTAKE_NOTE,
    [MedicalNoteType.Bps]: SourceDocumentType.BPS_NOTE,
    [MedicalNoteType.Progress]: SourceDocumentType.PROGRESS_NOTE,
    [MedicalNoteType.Soap]: SourceDocumentType.SOAP_NOTE,
    [MedicalNoteType.HeadwaySoap]: SourceDocumentType.HEADWAY_SOAP_NOTE,
    [MedicalNoteType.GpSoap]: SourceDocumentType.GP_SOAP_NOTE,
    [MedicalNoteType.Dap]: SourceDocumentType.DAP_NOTE,
    [MedicalNoteType.Emdr]: SourceDocumentType.EMDR_NOTE,
    [MedicalNoteType.Girp]: SourceDocumentType.GIRP_NOTE,
    [MedicalNoteType.Birp]: SourceDocumentType.BIRP_NOTE,
    [MedicalNoteType.Custom]: SourceDocumentType.CUSTOM_NOTE,
    [MedicalNoteType.PsySoap]: SourceDocumentType.PSY_SOAP_NOTE,
    [MedicalNoteType.PsyIntake]: SourceDocumentType.PSY_INTAKE_NOTE,
    [MedicalNoteType.Mse]: SourceDocumentType.MSE_NOTE,
    [MedicalNoteType.CoupleStandard]: SourceDocumentType.COUPLE_STANDARD_NOTE,
    [MedicalNoteType.CoupleSoap]: SourceDocumentType.COUPLE_SOAP_NOTE,
    [MedicalNoteType.CoupleDap]: SourceDocumentType.COUPLE_DAP_NOTE,
    [MedicalNoteType.Template]: SourceDocumentType.TEMPLATE,
} as const;
